module.exports = ng.core;